export default {
  specification: 'specyfikacja',
};
